import React from 'react'

export default function AboutLanding() {
  return (
    <div>
        <div className='row align-items-center py-5'>
            <div className="col-lg-6 col-sm-">
                
            </div>
            <div className='col-lg-6 col-sm-12'>
                <p className="h2">Courage Bernard</p>
                <p className='grey-text'>Fullstack Developer | Designer | Business Enthusiast</p>
                <p className="h4">Favorite Quote</p>
                <p className='grey-text'>It will all fall into place.</p>
                <p className="h4">Contact</p>
                <p className='grey-text'>Lagos, Nigeria</p>
                <p className='grey-text'>couragebernard77@gmail.com</p>
                <p className='grey-text'>+2348159702925</p>
                <div className='d-flex gap-3'>
                    <p className='grey-text' style={{fontSize:"20px"}}><a href='https://facebook.com/bernardcourage.clyde.7'><i class="bi bi-facebook"></i></a></p>
                    <p className='grey-text' style={{fontSize:"20px"}}><a href='https://twitter.com/Currie_Bee'><i class="bi bi-twitter"></i></a></p>
                    <p className='grey-text' style={{fontSize:"20px"}}><a href='https://www.instagram.com/currie_drk/'><i class="bi bi-instagram"></i></a></p>
                    <p className='grey-text' style={{fontSize:"20px"}}><a href='https://github.com/couragebernard'><i class="bi bi-github"></i></a></p>
                </div>
            </div>
                
            </div>
    </div>
  )
}
